import { LOCALE_ID, Provider } from '@angular/core';
import { LocalizationManagerService } from 'src/app/shared/services/localization-manager.service';


export class LocaleId extends String {
  constructor(private localizationManagerService: LocalizationManagerService) {
    super();
  }

  toString(): string {
    return this.localizationManagerService.getCurrentLocalization();
  }

  valueOf(): string {
    return this.toString();
  }
}

export const LocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: LocaleId,
  deps: [LocalizationManagerService],
};